var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#search_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m15.631 14.4-4.318-4.318a5.98 5.98 0 0 0 1.34-3.775 6.017 6.017 0 0 0-6.01-6.01 6.017 6.017 0 0 0-6.01 6.01 6.017 6.017 0 0 0 6.01 6.01c1.43 0 2.743-.504 3.776-1.34l4.317 4.317a.63.63 0 0 0 .895 0 .63.63 0 0 0 0-.894M6.643 11.05a4.75 4.75 0 0 1-4.745-4.745 4.75 4.75 0 0 1 4.745-4.744 4.75 4.75 0 0 1 4.745 4.744 4.75 4.75 0 0 1-4.745 4.745"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "search_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.633.296h15.184V15.48H.633z"
  })))));
};
export default SvgSearch;